import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Ban, Compass } from "lucide-react";

function Shell({ icon: Icon, code, title, message, testid }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-slate-50 px-6 text-center" data-testid={testid}>
      <Icon className="mb-4 h-12 w-12 text-indigo-300" />
      <p className="text-5xl font-bold tracking-tight text-slate-900">{code}</p>
      <p className="mt-3 text-lg font-semibold text-slate-700">{title}</p>
      <p className="mt-1 max-w-sm text-sm text-slate-500">{message}</p>
      <Button asChild className="mt-6" data-testid="go-home-btn">
        <Link to="/">Back to home</Link>
      </Button>
    </div>
  );
}

export function NotFound() {
  return (
    <Shell testid="not-found-page" icon={Compass} code="404" title="Page not found"
      message="The page you're looking for doesn't exist or may have moved." />
  );
}

export function Forbidden() {
  return (
    <Shell testid="forbidden-page" icon={Ban} code="403" title="Access denied"
      message="You don't have permission to view this page. Switch account or contact your administrator." />
  );
}
